import { VueConstructor } from 'vue';
import Vue from 'vue';
import GlobalHelper from '@/classes/common/globalHelper';

export function Gh(Vue: VueConstructor, options?: any): void {
  Vue.prototype.$globalHelper = new GlobalHelper();
}

Vue.use(Gh);
